/**
 * File view.js.
 *
 * Handles logo list blocks.
 */
(function ($) {
    'use strict';
    $(document).ready(function () {
        checkLastRowItems();

        $(window).on('resize', function(){
            checkLastRowItems();
        });
    });

    function checkLastRowItems() {
        $('.locations-worldwide').each(function(){
            let totalItems = $(this).find('.locations-worldwide__boxes .locations-worldwide__box').length;
            let dataCols = $(this).find('.locations-worldwide__boxes').data('columns') || 3;
            if ( 0 < totalItems ) {
                let windowWidth = $(window).outerWidth();
                let itemsPerRow = 1;
                
                if ( 991 < windowWidth ) {
                    itemsPerRow = parseInt( dataCols );
                } else if( 767 < windowWidth ) {
                    itemsPerRow = 2;
                }
                
                $(this).find('.locations-worldwide__boxes .locations-worldwide__box').removeClass('last-row-box');
                
                // Calculate the number of rows and items in the last row
                let itemsInLastRow = totalItems % itemsPerRow || itemsPerRow;

                // Calculate the starting index of the last row items
                let startIndex = totalItems - itemsInLastRow + 1;

                // Add a class to the last row items
                for (let i = startIndex; i <= totalItems; i++) {
                    $(this).find('.locations-worldwide__boxes .locations-worldwide__box:nth-child(' + i + ')').addClass('last-row-box');
                }
            }
        });
    }
})(jQuery);